import { firebaseConfig } from './shared/firebase.config';

export const environment = {
  production: true,
  useEmulators: true,
  firebaseConfig: firebaseConfig,
};
